import { validateUserAgent } from "../../organisms/utils.js";
import styled from "styled-components";

const ModalCustomContainer = styled.div`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  height: 100vh;
  position: absolute;
  padding-top: ${validateUserAgent() === "android" ? "113px" : "25px"}; ;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
  overflow:scroll;
  z-index: 1000;
`;

export default ModalCustomContainer;